/**
 * @file A bridge for communication with electron app
 * */
import window from 'bits/global'

function fetchElectronBridge(): any {
  return window.electron || {}
}

export default fetchElectronBridge
